<template>
    <div class="container" >
      <div v-if="isInCpcnWhite === 1">
        <div class="crumbs">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>
              <i class="el-icon-lx-cascades"></i>
              银行卡管理
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="bank-list">
          <div class="bank-add" @click="handleAddCard">
            <img
                    src="../../../../assets/img/pay/add.png"
                    style="width: 30px;height: 30px;margin-bottom: 6px;"
            />
            添加新卡片
          </div>
          <div class="bank-card" v-for="(item, index) in cardList" :key="index">
            <div class="bank-name">{{ item.bankName }}</div>
            <div class="bank-num">{{ formatBankNo(item.bankCardNo) }}</div>
            <div class="bank-btn-list">
              <div class="bank-btn" v-if="item.status != 40" @click="handleUnBunding(item)">解绑</div>
              <div
                      class="bank-btn"
                      style="width: 80px;"
                      v-if="item.status == 40"
                      @click="handleDeleteCard"
              >
                删除卡片
              </div>
              <div
                      class="bank-btn-solid"
                      style="width: 102px;"
                      v-if="item.status == 17 || item.status == 18"
                      @click="handleTest(item)"
              >
                输入验证金额
              </div>
              <div class="bank-btn-solid" v-if="item.status == 40" @click="handleReTest(item)">
                重新验证
              </div>
            </div>
            <div class="bank-badge" v-if="item.status == 30"></div>
            <div class="bank-text" v-if="item.status == 30">正常</div>

            <div class="bank-badge-ing" v-if="item.status == 17 || item.status == 18"></div>
            <div class="bank-text" v-if="item.status == 17 || item.status == 18">验证中</div>

            <div class="bank-badge-fail" v-if="item.status == 40"></div>
            <div class="bank-text-fail" v-if="item.status == 40">验证失败</div>
          </div>
        </div>

        <el-dialog
                title="添加新卡片"
                :visible.sync="visible"
                width="420px"
                :append-to-body="true"
                @close="handleClose"
        >
          <el-form
                  :model="form"
                  :rules="rules"
                  ref="form"
                  :label-position="'right'"
                  label-width="110px"
          >
            <el-form-item label="所属银行:" prop="bankId">
              <el-select
                      style="width: 200px"
                      v-model="form.bankId"
                      placeholder="请选择"
                      @change="selectChange"
              >
                <el-option
                        v-for="item in bankList"
                        :key="item.bankNumber"
                        :label="item.bankName"
                        :value="item.bankNumber"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行卡号:" prop="bankCardNo">
              <el-input
                      style="width: 200px"
                      v-model="form.bankCardNo"
                      placeholder="请输入银行卡号"
              ></el-input>
            </el-form-item>
            <el-form-item label="预留身份证号:" prop="idNumber">
              <el-input
                      style="width: 200px"
                      v-model="form.idNumber"
                      placeholder="请输入预留身份证号"
              ></el-input>
            </el-form-item>
            <el-form-item label="预留手机号:" prop="telephone">
              <el-input
                      style="width: 200px"
                      v-model="form.telephone"
                      placeholder="请输入预留手机号"
              ></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="footer-dialog">
            <div class="submit-btn" @click="handleSubmit">完成</div>
          </div>
        </el-dialog>
        <el-dialog
                title="小额打款验证"
                :visible.sync="amountVisible"
                width="400px"
                :append-to-body="true"
                @close="handleCloseAmount"
        >
          <el-form :model="amountForm" :rules="amountRules" ref="amountForm" :inline="false">
            <el-form-item label="请输入您网银账户中收到的一笔小额打款金额：" prop="amount">
              <el-input style="width: 300px" v-model="amountForm.amount"></el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="footer-dialog">
            <div class="submit-btn" @click="handleSubmitAmount">提交</div>
          </div>
        </el-dialog>
      </div>
      <no-permission  v-if="isInCpcnWhite === 2"/>
    </div>
  </template>
  
  <script>
  import api from "../../api/pay/index";
  import { idCardValidity, mobile } from "../../utils/verification";
  import noPermission from '../../components/pay/noPermission';
  export default {
    name: "EpecEaBankCardManagement",
    components:{
      noPermission
    },
    //10、处理中 15、待短信验证 17、待被动打款验证 18、被动已打款待验证 30、成功 40、失败',
    data() {
      return {
        isInCpcnWhite:3,//1 是有白名单，2是没有
        cardList: [],
        bankList: [],
        visible: false,
        form: {
          bankCardNo: "",
          bankId: "",
          idNumber: "",
          telephone: "",
          bankName: "",
          bankInfo: {},
        },
        rules: {
          bankCardNo: [{ required: true, message: "请输入银行卡号", trigger: "blur" }],
          bankId: [{ required: true, message: "请选择银行", trigger: "blur" }],
          idNumber: [
            { required: true, message: "请输入预留身份证号", trigger: "blur" },
            {
              pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
              message: "请输入正确的个人身份证号",
              trigger: "blur",
            },
            { required: true, validator: idCardValidity, trigger: "blur" },
          ],
          telephone: [{ required: true, validator: mobile, trigger: "blur" }],
        },
        amountVisible: false,
        amountForm: {
          amount: "",
          id: "",
        },
        amountRules: {
          amount: [
            { required: true, message: "请输入您网银账户中收到的一笔小额打款金额", trigger: "blur" },
          ],
        },
        accountObj: {},
      };
    },
  
    created() {
      this.isInCpcnWhiteList();
    },
  
    methods: {
      async isInCpcnWhiteList(){
        let res = await api.isInCpcnWhiteList();
        if (res.success) {
          if(res.data){
            this.isInCpcnWhite = 1;
            this.getBankCardList();
            this.getSelectBankList();
            this.getAccountList();
          }else{
            this.isInCpcnWhite = 2;
          }
        }
      },
      async getAccountList() {
        let res = await api.getAccountList();
  
        if (res.code == "200") {
          this.accountObj = res.data;
        }
      },
      async getSelectBankList() {
        let res = await api.getBankList();
  
        if (res.code == "200") {
          this.bankList = res.data;
        }
      },
      async getBankCardList() {
        let res = await api.getBankCardList();
  
        if (res.code == "200") {
          this.cardList = res.data;
        }
      },
      handleAddCard() {
        this.visible = true;
      },
      handleSubmit() {
        this.bankList.forEach(item => {
          if (item.bankNumber == this.form.bankId) this.form.bankName = item.bankName;
        });
  
        const { id: payAccountId } = this.accountObj;
        let params = {
          bankId: this.form.bankId,
          bankCardNo: this.form.bankCardNo,
          idNumber: this.form.idNumber,
          telephone: this.form.telephone,
          payAccountId,
          bankName: this.form.bankName,
        };
        this.$refs.form.validate(async val => {
          if (val) {
            let res = await api.submitBankData(params);
  
            if (res.code == "200") {
              this.$message({
                type: "success",
                message: "绑定银行卡成功，请耐心等待打款验证",
              });
              this.visible = false;
              this.getBankCardList();
              this.$refs.form.resetFields();
            }
          }
        });
      },
      handleClose() {
        this.visible = false;
        this.$refs.form.resetFields()
      },
      selectChange() {},
      async handleUnBunding(item) {
        let params = {
          id: item.id,
        };
        let res = await api.unBindBankCard(params);
  
        if (res.code == "200") {
          this.$message({
            type: "info",
            message: "解绑成功",
          });
          this.getBankCardList();
        }
      },
      handleDeleteCard() {},
      handleTest(item) {
        this.amountForm.id = item.id;
        this.amountVisible = true;
      },
      formatBankNo(str) {
        let reg = /^(\d{4})\d+(\d{4})$/;
  
        return str.replace(reg, "$1 **** **** **** $2");
      },
      handleCloseAmount() {
        this.amountVisible = false;
        this.$refs.amountForm.resetFields();
      },
      async handleSubmitAmount() {
        const { id: payAccountId } = this.accountObj;
        let params = {
          amount: this.amountForm.amount * 100,
          payAccountId,
          id: this.amountForm.id,
        };
        let res = await api.bindCardConfirm(params);
  
        if (res.code == "200") {
          this.$message({
            type: "info",
            message: "打款验证成功",
          });
          this.amountVisible = false;
          this.$refs.amountForm.resetFields();
          this.getBankCardList();
        }
      },
      handleReTest(item) {
        const { id: payAccountId } = this.accountObj;
        let params = {
          bankId: item.bankId,
          bankCardNo: item.bankCardNo,
          idNumber: item.idNumber,
          telephone: item.telephone,
          payAccountId,
          bankName: item.bankName,
        };
        this.$refs.form.validate(async val => {
          if (val) {
            let res = await api.submitBankData(params);
  
            if (res.code == "200") {
              this.$message({
                type: "success",
                message: "绑定银行卡成功，请耐心等待打款验证",
              });
              this.visible = false;
              this.getBankCardList();
              this.$refs.form.resetFields();
            }
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .bank-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .bank-add {
      color: #2587ff;
      font-size: 12px;
      width: 260px;
      height: 116px;
      border: 1px solid #dcdcdc;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      margin-right: 30px;
      margin-top: 20px;
      &:hover {
        border: 1px solid #2587ff;
      }
    }
    .bank-card {
      width: 260px;
      height: 116px;
      border: 1px solid #dcdcdc;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-right: 30px;
      margin-top: 20px;
      position: relative;
      cursor: pointer;
      &:hover {
        border: 1px solid #2587ff;
      }
      .bank-badge {
        position: absolute;
        background: #2587ff;
        width: 77px;
        height: 77px;
        top: 0px;
        right: 0px;
        clip-path: polygon(0 0, 100% 57%, 100% 0);
        display: flex;
        justify-content: flex-end;
      }
      .bank-badge-ing {
        position: absolute;
        background: #06bc7e;
        width: 77px;
        height: 77px;
        top: 0px;
        right: 0px;
        clip-path: polygon(0 0, 100% 57%, 100% 0);
        display: flex;
        justify-content: flex-end;
      }
      .bank-badge-fail {
        position: absolute;
        background: #f0250f;
        width: 77px;
        height: 77px;
        top: 0px;
        right: 0px;
        clip-path: polygon(0 0, 100% 57%, 100% 0);
        display: flex;
        justify-content: flex-end;
      }
      .bank-text {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 4;
        color: #fff;
        transform: rotate(30deg);
        transform-origin: 50% 50%;
        height: 60px;
        width: 60px;
        text-align: center;
        line-height: 30px;
        white-space: nowrap;
        font-size: 12px;
      }
      .bank-text-fail {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 4;
        color: #fff;
        transform: rotate(30deg);
        transform-origin: 50% 50%;
        height: 70px;
        width: 70px;
        text-align: center;
        line-height: 30px;
        white-space: nowrap;
        font-size: 12px;
      }
      .bank-name {
        font-weight: 700;
        font-size: 18px;
        color: #333333;
        margin-bottom: 10px;
      }
      .bank-num {
        font-size: 14px;
        color: #333333;
        margin-bottom: 10px;
      }
      .bank-btn-list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        .bank-btn {
          width: 60px;
          height: 24px;
          border: 1px solid #2587ff;
          margin-left: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #2587ff;
          cursor: pointer;
          background: #e8efff;
          &:hover {
            background: #2587ff;
            color: #ffffff;
          }
          &:focus {
            background: #2587ff;
            color: #ffffff;
          }
        }
        .bank-btn-solid {
          width: 80px;
          height: 24px;
          background: #2587ff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          margin-left: 20px;
          &:hover {
            background: #2587ff;
          }
          &:focus {
            background: #2587ff;
          }
        }
      }
    }
  }
  .footer-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    .submit-btn {
      width: 80px;
      height: 30px;
      background: #2587ff;
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
      cursor: pointer;
    }
  }
  </style>
  